import refundStatus from '@/helpers/refundStatusHelper'

export default function () {
  return {
    refundStatus,
    refunds: [],
    refundFormOpen: false,
    showDatePicker: false,
    refundToDelete: null,
    refundForm: {
      description: '',
      overtime: false,
      date: '',
      displayDate: '',
      amount: null,
      file: null,
    },
    errors: {
      description: null,
      date: null,
      amount: null,
      file: null
    },
    successMessage: {
      show: false,
      content: null
    },
    errorMessage: {
      show: false,
      content: null
    }
  }
}
